// // frontend\src\app\App.js
// import AppRoutes from "./routes";
// import { AuthProvider } from "features/auth/context/AuthContext";
// import "styles/global.css";

// // spoorthi cloned

// export default function App() {
//   return (
//     <AuthProvider>
//       <AppRoutes />
//     </AuthProvider>
//   );
// }
import React from "react";
import { AuthProvider } from "../features/auth/context/AuthContext";
import AppRoutes from "./routes";
import "styles/global.css";

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
